import { useEffect, type ReactNode } from 'react'
import { useAuth } from '@/lib/auth/AuthProvider'
import { tokens } from '@/lib/auth/tokens'
import { connectWs, disconnectWs, reconnectWs } from './client'

export function RealtimeRoot({ children }: { children: ReactNode }) {
  const { status, user } = useAuth()
  const ready = status === 'authenticated' && !!user && !user.must_change_password

  useEffect(() => {
    if (!ready) {
      disconnectWs()
      return
    }
    connectWs()
    return tokens.onAccessChange((access) => {
      if (!access) disconnectWs()
      else reconnectWs()
    })
  }, [ready])

  return children
}
